import { LearningRecommendationsService } from '@/services/learningRecommendation'
import {
  ApiErrorResponse,
  ApiPaginatedResponse,
  ApiSortingParams,
} from '@/types/api'
import { IRecommendationOnTheList } from '@/types/recommendations'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

export type UseLearningRecommendationsOptions = {
  sortBy?: ApiSortingParams
  status?: 'not_generated' | 'ready' | 'generating' | 'error'
  limit?: number
  page?: number
  queryOptions?: Omit<
    UseQueryOptions<
      ApiPaginatedResponse<IRecommendationOnTheList>,
      ApiErrorResponse,
      ApiPaginatedResponse<IRecommendationOnTheList>
    >,
    'queryKey' | 'queryFn'
  >
}

export const useLearningRecommendations = ({
  sortBy,
  status,
  limit,
  page,
  queryOptions = {},
}: UseLearningRecommendationsOptions = {}) => {
  return useQuery({
    queryKey: [
      'learning-recommendations',
      ...(sortBy ? ['sortBy', sortBy] : []),
      ...(status ? ['status', status] : []),
      ...(limit ? ['limit', limit] : []),
      ...(page ? ['page', page] : []),
    ],
    queryFn: () =>
      LearningRecommendationsService.list({
        filters: { sortBy, status },
        pagination: { limit, page },
      }),
    ...queryOptions,
  })
}
